import axios from 'axios';

export const generateEmailPreview = async (emailConfig: object) => {
  const res = await axios.post('/api/email/generate-html', emailConfig);
  const emailPreview = await res.data;
  return emailPreview;
};
